// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/state-machines/invitation-machine.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/state-machines/src/invitation-machine.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo daily-journal-app
//     node fleet/fleet.ts check --repo daily-journal-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { fromPromise, setup } from "xstate";

export type InvitationEvent =
  | { type: "ACCEPT" }
  | { type: "REJECT" }
  | { type: "RETRY_ACCEPT" }
  | { type: "RETRY_REJECT" };

export interface InvitationContext {
  id: string;
  error: string | null;
}

export const invitationMachine = setup({
  // Schema Definition Pattern for XState v5 type inference
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  types: {} as {
    context: InvitationContext;
    events: InvitationEvent;
    input: { id: string };
  },
  actors: {
    // oxlint-disable-next-line typescript/require-await
    acceptActor: fromPromise(async ({ input }: { input: { id: string } }) => {
      // Overridden
      console.log("Accepting", input.id);
    }),
    // oxlint-disable-next-line typescript/require-await
    rejectActor: fromPromise(async ({ input }: { input: { id: string } }) => {
      // Overridden
      console.log("Rejecting", input.id);
    }),
  },
}).createMachine({
  id: "invitation",
  initial: "idle",
  context: ({ input }) => ({
    id: input.id,
    error: null,
  }),
  states: {
    idle: {
      on: {
        ACCEPT: "accepting",
        REJECT: "rejecting",
      },
    },
    accepting: {
      invoke: {
        src: "acceptActor",
        input: ({ context }) => ({ id: context.id }),
        onDone: "accepted",
        onError: "error",
      },
    },
    rejecting: {
      invoke: {
        src: "rejectActor",
        input: ({ context }) => ({ id: context.id }),
        onDone: "rejected",
        onError: "error",
      },
    },
    accepted: {
      type: "final",
    },
    rejected: {
      type: "final",
    },
    error: {
      on: {
        RETRY_ACCEPT: "accepting",
        RETRY_REJECT: "rejecting",
        ACCEPT: "accepting",
        REJECT: "rejecting",
      },
    },
  },
});
